import { matchPath } from 'react-router'
import UrlLocation from 'src/lib/url/UrlLocation'

/**
 * App-level wrapper around React Router's `matchPath` for matching regional
 * routes against the real browser/Redux pathname.
 *
 * Use this when matching paths that may include locale-shaped URL segments,
 * e.g. `/au/de-DE/hotels` or `/au/offer/de-DE/abc123`, against existing route
 * patterns such as `/:regionCode/hotels`. Use raw `matchPath` when the pathname
 * is already stripped by `LocaleAwareRoute`, or when the code intentionally needs
 * exact raw URL semantics.
 */
export function matchLocaleAwarePath<Params extends { [K in keyof Params]?: string | undefined } = Record<string, string | undefined>>(
  pathname: string,
  pattern: Parameters<typeof matchPath>[1],
) {
  return matchPath<Params>(new UrlLocation(pathname).withoutLocale().path, pattern)
}
